import React from 'react';
import PropTypes from 'prop-types';

const InquiryData = ({ label, value, children }) => (
  <>
  {label && value && <div className="inquiry-data mb-5 w-1/2">
    <p className="inquiry-data-label text-gray-500 font-bold text-xs">
      {label}
    </p>
    <div className="inquiry-data-value">
      {value.split('\n').map((val, index) => (
        val && <p key={index} className="font-medium text-sm">{val}</p>
      ))}
    </div>
    {children}
  </div>}
  </>
);

InquiryData.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  children: PropTypes.node
};

export default InquiryData;
